import React from "react";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { usePartnerProgram } from "../../contexts/PartnerProgramContext";
import usePartnerSigningOpen from "../../hooks/usePartnerSigningOpen";
import { browseBandCopy, isBrowsing } from "../../lib/partnerSigningOpen";
import { tt } from "../../i18n/tt";

/**
 * 둘러보기 띠 (2026-09-11, 시안 V1 — docs/design/partner-center-browse-variants.html · 기획 docs/ops/partner-center-access-plan.md §5-3)
 *   약관 서명 전(status=pending) 파트너에게 파트너센터 **모든 화면**(홈·가이드·유치·영업·정산) 맨 위에 한 줄:
 *   「둘러보기 중이에요 — …」 + 단추 하나. 스위치가 켜져 있으면 「서명하기」(홈 ?sign=1), 꺼져 있으면 「약관 미리 읽기」(홈 ?terms=preview).
 *   원장은 PartnerProgramContext(레일과 같은 행)를 읽는다 — 행이 아직 없으면(첫 방문) 허브가 만들 때까지 아무것도 그리지 않는다.
 *   서명 뒤(status≠pending)에는 사라진다. 둘러보기는 **화면 표시 상태**이고 원장에는 아무것도 쓰지 않는다.
 */
export default function PartnerBrowseBand() {
  const ctx = usePartnerProgram();
  const program = ctx?.program || null;
  const { enabled: signingOpen } = usePartnerSigningOpen();
  const navigate = useNavigate();
  const location = useLocation();
  if (!program || !isBrowsing(program.status)) return null;
  const copy = browseBandCopy({ signingOpen });
  const go = () => navigate(copy.cta === "sign" ? "/partner?sign=1" : "/partner?terms=preview");
  const onHome = location.pathname === "/partner";
  return (
    <Box role="status" data-testid="partner-browse-band" bg={signingOpen ? "brand.50" : "statusWash.warning"} borderBottom="1px solid" borderColor={signingOpen ? "brand.200" : "statusLine.warning"} px={{ base: 4, md: 5 }} py={2}>
      <Flex align="center" gap={3} maxW="1400px" mx="auto" fontSize="xs" color="neutral.800" flexWrap="wrap">
        <Text as="span" fontWeight="700" color={signingOpen ? "brand.700" : "status.warning"}>{tt("a.65f5c2b5", "둘러보기 중이에요")}</Text>
        <Text as="span">{tt(copy.bodyKey, copy.bodyKo)}</Text>
        <Button size="xs" ml="auto" colorScheme={signingOpen ? "brand" : "gray"} variant={signingOpen ? "solid" : "outline"} onClick={go} data-cta={copy.cta}>
          {tt(copy.ctaKey, copy.ctaKo)}{onHome ? "" : " →"}
        </Button>
      </Flex>
    </Box>
  );
}
